class RecordListPaginationCtrl {
  constructor() {
   
    this.start = this.startIdx(); 
  }

  nextPage(){
    if(this.hasNext()){ 
       this.pageNumber++;
    }
  }

  previousPage(){
    if (this.hasPrevious()){
      this.pageNumber--;
    }
  }

  hasPrevious(){
    return this.pageNumber > 0;
  }

  hasNext(){
    return this.endIdx() < this.recordCount;
  }

  pageThroughSize(){
    const through = Math.min(this.endIdx(), this.recordCount);
    return through;
  }

  pageStart(){
    return this.pageNumber * this.pageSize;
  }

  startIdx() {
    return this.recordCount? this.pageStart() + 1: 0;
  }

  endIdx() {
    return this.pageStart() + this.pageSize;
  }

}

export default {
  bindings:{
    records: '<',
    pageSize: '<',
    recordCount: '<',
    pageNumber: '=',
    start: '='
  },
  templateUrl: 'record-utilities/pagination/record-list-pagination.component.html',
  controller: RecordListPaginationCtrl
}